export const INVOICES_FORECAST = 'INVOICES_FORECAST'
export const INVOICES_FORECAST_SUCCESS = 'INVOICES_FORECAST_SUCCESS'
export const INVOICES_FORECAST_FAILED = 'INVOICES_FORECAST_FAILED'

export const SEND_INVOICE_FORECAST_REPORT = 'SEND_INVOICE_FORECAST_REPORT'
export const SEND_INVOICE_FORECAST_REPORT_SUCCESS = 'SEND_INVOICE_FORECAST_REPORT_SUCCESS'
export const SEND_INVOICE_FORECAST_REPORT_FAILED = 'SEND_INVOICE_FORECAST_REPORT_FAILED'

export const CLEAR_INVOICES_FORECAST = 'CLEAR_INVOICES_FORECAST'
